// Routes owned by the Drive module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const drivePaths = {
    drive: '/drive',
} as const
